import { Button, Col, Container, Row, Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { useEffect, useState } from 'react';

function App() {
	const [circulatingSupply, setCirculatingSupply] = useState();
	const [topHolders, setTopHolders] = useState();
	const [activeWitnesses, setActiveWitnesses] = useState();
	const [activeCommittees, setActiveCommittees] = useState();
	const [totalSupply, setTotalSupply] = useState();
	const [searchValue, setSearchValue] = useState('');
	const [searchResult, setSearchResult] = useState();
	const [searchValueBlock, setSearchValueBlock] = useState('');
	const [searchResultBlock, setSearchResultBlock] = useState();
	const [searchError, setSearchError] = useState('');
	const [lastBlockNumber, setLastBlockNumber] = useState();
	const [activeWitnessesCount, setactiveWitnessesCount] = useState();
	const [activeCommitteesCount, setactiveCommitteesCount] = useState();
	const [recentBlocks, setRecentBlocks] = useState();

	function addCommas(x) {
		var parts = x.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}
	
	function search()
	{
		setSearchError('');
		function timeout(ms, promise) {
			return new Promise(function(resolve, reject) {
			  setTimeout(function() {
				reject(new Error("timeout"))
			  }, ms)
			  promise.then(resolve, reject)
			})
		  }
		  
		  timeout(3000, fetch(`https://elasticsearch.tusc.network/full_account?account_id=${searchValue}`)).then(function(res) {
		  	if(res.status !== 200)
		  		setSearchError('Not Found!');
		  	else{
				  (async ()=>{
					const response = await (await fetch(res.url)).json();
					if(response.account){
						setSearchResult({
							id: response.account.id,
							name:response.account.name,
							balance:response.balances.length?response.balances[0].balance/100000:0,
						})
					}
					else
						setSearchError('Not Found!');
				})()
			  }
		  }).catch(function(error) {
			setSearchError('Not Found!');
		  })
	}

	async function searchBlock()
	{
		setSearchResultBlock(await (await fetch(`https://elasticsearch.tusc.network/block?block_num=${searchValueBlock}`)).json());
	}

	useEffect(() => {
		setInterval(async () => {
			setCirculatingSupply(await (await fetch('https://elasticsearch.tusc.network/circulating_supply?object=2.3.0')).json());
			const lastBlockNum = await (await fetch('https://elasticsearch.tusc.network/last_block_number')).json();
			setLastBlockNumber(lastBlockNum);
			setTotalSupply(await (await fetch('https://elasticsearch.tusc.network/total_supply?object=2.3.0')).json());
			let blocks = []
			for(let i=0; i<10; i++)
			{
				blocks[i] = await (await fetch(`https://elasticsearch.tusc.network/block?block_num=${lastBlockNum-i}`)).json();
			}
			setRecentBlocks(blocks);
			setTopHolders((await (await fetch('https://elasticsearch.tusc.network/top_holders')).json()).slice(0,10));
			setActiveWitnesses((await (await fetch('https://elasticsearch.tusc.network/witnesses')).json()).slice(0,21));
			setActiveCommittees((await (await fetch('https://elasticsearch.tusc.network/committee_members')).json()).slice(0,11));
			const {committee_count, witness_count} = await (await fetch('https://elasticsearch.tusc.network/header')).json();
			setactiveWitnessesCount(witness_count);
			setactiveCommitteesCount(committee_count);
		}, 3000);
	}, [])

	return (
		<Container fluid>
			<Row className='justify-content-center'>
				<Col xs={12} className='text-center title py-2'>
					TUSC Explorer
				</Col>
				<Col xs={12}>
					<Row className='justify-content-center p-3'>
						<Col xs={12} lg={11} className='d-flex justify-content-around flex-wrap Card py-2 my-2'>

							<div className='d-flex flex-column align-items-center p-0'>
								<div>CURRENT BLOCK</div>
								<div>{lastBlockNumber?addCommas(lastBlockNumber):'Loading...'}</div>
							</div>
							
							<div className='d-flex flex-column align-items-center p-0'>
								<div>CIRCULATING SUPPLY</div>
								<div>{circulatingSupply?addCommas(Math.round(circulatingSupply*100)/100):'Loading...'}</div>
							</div>

							<div className='d-flex flex-column align-items-center p-0'>
								<div>TOTAL SUPPLY</div>
								<div>{totalSupply?addCommas(Math.round(totalSupply*100)/100):'Loading...'}</div>
							</div>

							<div className='d-flex flex-column align-items-center p-0'>
								<div>ACTIVE WITNESSES</div>
								<div>{activeWitnessesCount?activeWitnessesCount:'Loading...'}</div>
							</div>

							<div className='d-flex flex-column align-items-center p-0'>
								<div>ACTIVE COMMITTEES</div>
								<div>{activeCommitteesCount?activeCommitteesCount:'Loading...'}</div>
							</div>

						</Col>

						<Col md={12} lg={11} className='Card mx-1 py-2 my-2 align-items-center'>
							<Row>
							<Col xs={12} sm={6} className='my-2 py-2 d-flex flex-wrap justify-content-center align-items-center'>
								<div>SEARCH ACCOUNT </div>
								<input className='mx-3' value={searchValue} onChange={e=>setSearchValue(e.target.value)}/>
								<Button variant='light' onClick={search}>SHOW</Button>
							</Col>
							{
								searchError?<Col xs={12} sm={6} className='text-center'>{searchError}</Col>:searchResult &&
								<Col xs={12} sm={6}>
									<div className='d-flex justify-content-around py-3 col-12'>
										<div className='d-flex flex-column align-items-center p-0 mx-2'>
											<div>ID</div>
											<div>{searchResult.id}</div>
										</div>
										<div className='d-flex flex-column align-items-center p-0 mx-2'>
											<div>NAME</div>
											<div>{searchResult.name}</div>
										</div>
										<div className='d-flex flex-column align-items-center p-0 mx-2'>
											<div>BALANCE</div>
											<div>{addCommas(Math.round(searchResult.balance*100)/100)}</div>
										</div>
									</div>
								</Col>
							}
							</Row>
						</Col>

						<Col md={12} lg={11} className='Card mx-1 py-2 my-2 align-items-center'>
							<Row>
							<Col xs={12} sm={6} className='my-2 py-2 d-flex flex-wrap justify-content-center align-items-center'>
								<div>SEARCH BLOCK </div>
								<input className='mx-3' value={searchValueBlock} onChange={e=>setSearchValueBlock(e.target.value)}/>
								<Button variant='light' onClick={searchBlock}>SHOW</Button>
							</Col>
							{
								searchResultBlock && searchResultBlock.witness?
								<Col xs={12} sm={6}>
									<div className='d-flex justify-content-around py-3 col-12'>
										<div className='d-flex flex-column align-items-center p-0 mx-2'>
											<div>BLOCK ID</div>
											<div><a className='text-light' target='_blank' rel="noopener noreferrer" href={`https://test-tusc.tusc.network/wallet/block/${searchValueBlock}`}>{searchValueBlock}</a></div>
										</div>
										<div className='d-flex flex-column align-items-center p-0 mx-2'>
											<div>DATE</div>
											<div>{searchResultBlock.timestamp.slice(0,10)}</div>
										</div>
										<div className='d-flex flex-column align-items-center p-0 mx-2'>
											<div>WITNESS</div>
											<div>{searchResultBlock.witness}</div>
										</div>
										<div className='d-flex flex-column align-items-center p-0 mx-2'>
											<div>TRANSACTION COUNT</div>
											<div>{searchResultBlock.transactions.length}</div>
										</div>
									</div>
								</Col>:searchResultBlock &&
								<Col xs={12} sm={6} className='text-center'>Not Found!</Col>
							}
							</Row>
						</Col>

					</Row>

					
					<Row className='justify-content-center p-3'>
						<Col md={12} lg={5} className='Card mx-1 py-2 my-2'>
							<h5 className='text-center pb-3'><b>RECENT BLOCKS</b></h5>
							<Table responsive="sm" borderless className='text-light text-center'>
								<thead>
									<tr className='border-bottom'>
										<th>BLOCK ID</th>
										<th>DATE</th>
										<th>WITNESS</th>
										<th>TRANSACTION COUNT</th>
									</tr>
								</thead>
								<tbody>
									{
										recentBlocks?
										recentBlocks.map((b,id)=>{
											return(
												<tr key={id}>
													<td><a className='text-light' target='_blank' rel="noopener noreferrer" href={`https://test-tusc.tusc.network/wallet/block/${lastBlockNumber-id}`}>{lastBlockNumber-id}</a></td>
													<td style={{'width':'25%'}}>{b.timestamp.slice(0,10)}</td>
													<td>{b.witness}</td>
													<td>{b.transactions.length}</td>
												</tr>
											)
										}):
										<tr><td colSpan='4'>Loading...</td></tr>
									}
								</tbody>
							</Table>
						</Col>

						<Col md={12} lg={6} className='Card mx-1 py-2 my-2'>
							<h5 className='text-center pb-3'><b>TOP HOLDERS</b></h5>
							<Table responsive="sm" borderless className='text-light text-center'>
								<thead>
									<tr className='border-bottom'>
										<th>ID</th>
										<th>NAME</th>
										<th>BALANCE</th>
										<th>% OF SUPPLY</th>
									</tr>
								</thead>
								<tbody>
									{
										topHolders?
										topHolders.map((h,id)=>{
											return(
												<tr key={id}>
													<td>{h.account_id}</td>
													<td>{h.account_name}</td>
													<td>{addCommas(Math.round(h.amount/1000)/100)}</td>
													<td>{Math.round((h.amount/10)/totalSupply)/100}</td>
												</tr>
											)
										}):
										<tr><td colSpan='4'>Loading...</td></tr>
									}
								</tbody>
							</Table>
						</Col>
						
						<Col md={12} lg={11} className='Card mx-1 py-2 my-2'>
							<h5 className='text-center pb-3'><b>ACTIVE WITNESSES</b></h5>
							<Table responsive="sm" borderless className='text-light text-center'>
								<thead>
									<tr className='border-bottom'>
										<th>#</th>
										<th>ID</th>
										<th>NAME</th>
										<th>URL</th>
										<th>LAST BLOCK NUM</th>
										<th>BLOCKS MISSED</th>
										<th>VOTES</th>
									</tr>
								</thead>
								<tbody>
									{
										activeWitnesses?
										activeWitnesses.map((w,id)=>{
											return(
												<tr key={id}>
													<td>{id+1}</td>
													<td>{w.id}</td>
													<td>{w.witness_account_name}</td>
													<td><a href={w.url} className='text-light'>url</a></td>
													<td>{addCommas(w.last_confirmed_block_num)}</td>
													<td>{addCommas(w.total_missed)}</td>
													<td>{addCommas(Math.round(w.total_votes/1000)/100)}</td>
												</tr>
											)
										}):
										<tr><td colSpan='7'>Loading...</td></tr>
									}
								</tbody>
							</Table>
						</Col>
						<Col md={12} lg={11} className='Card mx-1 py-2 my-2'>
							<h5 className='text-center pb-3'><b>ACTIVE COMMITTEES</b></h5>
							<Table responsive="sm" borderless className='text-light text-center'>
								<thead>
									<tr className='border-bottom'>
										<th>#</th>
										<th>ID</th>
										<th>NAME</th>
										<th>VOTES</th>
										<th>URL</th>
									</tr>
								</thead>
								<tbody>
									{
										activeCommittees?
										activeCommittees.map((c,id)=>{
											return(
												<tr key={id}>
													<td>{id+1}</td>
													<td>{c[0].id}</td>
													<td>{c[0].committee_member_account_name}</td>
													<td>{addCommas(Math.round(c[0].total_votes/1000)/100)}</td>
													<td><a href={c[0].url} className='text-light'>url</a></td>
												</tr>
											)
										}):
										<tr><td colSpan='5'>Loading...</td></tr>
									}
								</tbody>
							</Table>
						</Col>
					</Row>
				</Col>
			</Row>
		</Container>
	);
}

export default App;